import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { ApplicationCard } from './ApplicationCard.jsx';

const STATUS_COLORS = {
  saved: 'bg-status-saved',
  applied: 'bg-status-applied',
  interviewing: 'bg-status-interviewing',
  offer: 'bg-status-offer',
  rejected: 'bg-status-rejected',
};

export function Column({ status, label, apps, onCardClick, onContextMenu }) {
  const { setNodeRef, isOver } = useDroppable({ id: status });

  const sortedApps = [...apps].sort((a, b) => a.columnOrder - b.columnOrder);
  const appIds = sortedApps.map((a) => a.appId);

  return (
    <div className="flex w-64 shrink-0 flex-col rounded-lg bg-slate-50 max-h-full" role="region" aria-label={`${label} column, ${apps.length} applications`}>
      <div className="flex items-center gap-2 px-3 py-2">
        <span className={`size-2.5 rounded-full ${STATUS_COLORS[status]}`} />
        <h2 className="text-sm font-semibold text-slate-700">{label}</h2>
        <span className="ml-auto text-xs text-slate-400">{apps.length}</span>
      </div>

      <div
        ref={setNodeRef}
        className={`flex-1 space-y-2 overflow-y-auto px-2 pb-2 min-h-[120px] transition-colors ${
          isOver ? 'bg-primary-50' : ''
        }`}
      >
        <SortableContext items={appIds} strategy={verticalListSortingStrategy}>
          {sortedApps.length === 0 && (
            <p className="py-8 text-center text-xs text-slate-400">Drag cards here</p>
          )}
          {sortedApps.map((app) => (
            <ApplicationCard key={app.appId} app={app} onClick={onCardClick} onContextMenu={onContextMenu} />
          ))}
        </SortableContext>
      </div>
    </div>
  );
}
